export function getView(connection_resource_status, is_admin) {
  return is_admin && connection_resource_status === 'enabled'
}
